import { render, staticRenderFns } from "./SelectChatParticipantsModal.vue?vue&type=template&id=1c277ef7&scoped=true&"
import script from "./SelectChatParticipantsModal.vue?vue&type=script&lang=js&"
export * from "./SelectChatParticipantsModal.vue?vue&type=script&lang=js&"
import style0 from "./SelectChatParticipantsModal.vue?vue&type=style&index=0&id=1c277ef7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c277ef7",
  null
  
)

export default component.exports